var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/add-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7934 1.33333H5.20671C2.78004 1.33333 1.33337 2.78 1.33337 5.20667V10.7867C1.33337 13.22 2.78004 14.6667 5.20671 14.6667H10.7867C13.2134 14.6667 14.66 13.22 14.66 10.7933V5.20667C14.6667 2.78 13.22 1.33333 10.7934 1.33333ZM10.6667 8.5H8.50004V10.6667C8.50004 10.94 8.27337 11.1667 8.00004 11.1667C7.72671 11.1667 7.50004 10.94 7.50004 10.6667V8.5H5.33337C5.06004 8.5 4.83337 8.27333 4.83337 8C4.83337 7.72667 5.06004 7.5 5.33337 7.5H7.50004V5.33333C7.50004 5.06 7.72671 4.83333 8.00004 4.83333C8.27337 4.83333 8.50004 5.06 8.50004 5.33333V7.5H10.6667C10.94 7.5 11.1667 7.72667 11.1667 8C11.1667 8.27333 10.94 8.5 10.6667 8.5Z",
    fill: "#171717"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuMore);
export default __webpack_public_path__ + "static/media/course_menu_more.d4d7e096b98d21c313e15b28a657b305.svg";
export { ForwardRef as ReactComponent };